export const DAY_IN_MS = 24 * 60 * 60 * 1000;
export const WEEKS_IN_YEAR = 52;